import React from 'react';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Planificador de Rendimiento Handball 12 Semanas',
  value: '$15.000'
}, {
  num: 2,
  title: 'Atlas de Ejercicios para Handball',
  value: '$12.500'
}, {
  num: 3,
  title: 'Rutinas Express para Jugadores con Poco Tiempo',
  value: '$9.900'
}];
export function Bonuses() {
  return <section className="py-12 px-4 bg-brand-dark border-t border-b border-accent-base/30 relative overflow-hidden" data-id="element-14">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-accent-base/10 blur-[100px] rounded-full pointer-events-none" data-id="element-15"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-16">
        <div className="text-center mb-8" data-id="element-17">
          <span className="inline-block bg-accent-base text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-3 animate-pulse" data-id="element-18">
            Solo por hoy
          </span>
          <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white uppercase tracking-wide" data-id="element-19">
            Bonos <span className="text-accent-base" data-id="element-20">Gratis</span>
          </h2>
          <p className="text-gray-300 mt-2" data-id="element-21">
            Llevate estos complementos sin costo adicional con tu compra de hoy.
          </p>
        </div>

        <div className="flex flex-col gap-4" data-id="element-22">
          {bonuses.map(b => <div key={b.num} className="bg-gradient-to-r from-brand-light to-brand-base border border-accent-base/50 rounded-xl p-5 md:p-6 flex items-center gap-4 relative overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.3)]" data-id="element-23">
              {/* Ribbon */}
              <div className="absolute -right-10 top-4 bg-accent-base text-white text-[10px] font-bold uppercase tracking-wider py-1 px-10 rotate-45 shadow-md" data-id="element-24">
                Gratis
              </div>

              <div className="flex-shrink-0 bg-brand-dark p-3 rounded-full border border-accent-base/30" data-id="element-25">
                <Gift className="w-6 h-6 text-accent-base" data-id="element-26" />
              </div>

              <div className="flex-1 pr-8" data-id="element-27">
                <span className="text-accent-base text-xs font-bold tracking-wider uppercase mb-1 block" data-id="element-28">
                  Bono {b.num}
                </span>
                <h3 className="text-white font-medium text-base md:text-lg leading-tight mb-2" data-id="element-29">
                  {b.title}
                </h3>
                <div className="flex items-center gap-2 text-sm" data-id="element-30">
                  <span className="text-gray-500 line-through" data-id="element-31">
                    Valor: {b.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-32">HOY $0</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}